const combine = (a = [], b = []) => {
  const res = {};
  a.forEach((value, index) => res[value] = b[index]);
  return res;
};

const hasItems = (array = []) => (
  Array.isArray(array) && array.length
);

export const arrayHelper = {
  combine,
  hasItems,
};



// WEBPACK FOOTER //
// ./src/_shared/utils/arrayHelper.js